import {useSelector} from "react-redux"
import {EDITOR_MODE_RICH} from "../../constants/EditorMode"
import tinymce from "tinymce"
import React from "react"

export default function GrammarCheckButton() {
  const canPublish = useSelector(state => state.post.uploadProgressCount === 0)
  const editorMode = useSelector(state => state.env.editorMode)

  if (editorMode !== EDITOR_MODE_RICH) {
    return null
  }

  function handleGrammarCheck() {
    if (!canPublish) {
      return;
    }
    tinymce.activeEditor.execCommand('grammarCheck')
  }

  return (
    <button className="btn_type1" onClick={handleGrammarCheck}>
      <span className="mce-ico ico_validator" />
      <span className="btn_txt">맞춤법검사</span>
    </button>
  )
}
